import { StackGrid } from "@data-display/layout/StackGrid";
import { TextFieldForm } from "@inputs/hook-form";
import { MenuItem, Stack } from "@mui/material";
import { DateRangePickerTextField } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { TTrainingSharedFormFieldValues } from "../types";
import { type ITrainingSharedFormSectionProps, VALIDATIONS, WAGES } from "./shared";

interface ITrainingSharedFormAboutProps<TForm extends TTrainingSharedFormFieldValues>
  extends ITrainingSharedFormSectionProps<TForm> {
  control: Control<TForm>;
  nameLabel: string;
}

export const TrainingSharedFormAbout = <TForm extends TTrainingSharedFormFieldValues>({
  control,
  fields,
  nameLabel,
}: ITrainingSharedFormAboutProps<TForm>) => {
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <TextFieldForm control={control} name={fields.name} label={nameLabel} fullWidth size="small" />
      <StackGrid rowGap={2} columnGap={2} perLine={{ tablet: 2 }}>
        <Controller
          control={control}
          name={fields.period}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <DateRangePickerTextField
              label="Période *"
              value={value ?? { startDate: null, endDate: null }}
              onChange={onChange}
              error={!!error}
              helperText={error ? error.message : null}
              required={{ startDate: true, endDate: true }}
            />
          )}
        />
        <TextFieldForm control={control} name={fields.validation} label="Validation" select size="small" clearable>
          {VALIDATIONS.map((validation) => (
            <MenuItem key={validation.value} value={validation.value}>
              {validation.label}
            </MenuItem>
          ))}
        </TextFieldForm>
        <TextFieldForm control={control} name={fields.wage} label="Rémunération" select size="small" clearable>
          {WAGES.map((wage) => (
            <MenuItem key={wage.value} value={wage.value}>
              {wage.label}
            </MenuItem>
          ))}
        </TextFieldForm>
      </StackGrid>
    </Stack>
  );
};
